// useCheckMobileScreen.js
import { useEffect, useState } from "react";
import debounce from "lodash.debounce";

const useCheckMobileScreen = () => {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia("(max-width: 767px)").matches);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 767px)");

    const handleChange = debounce(() => {
      setIsMobile(mediaQuery.matches);
    }, 100); // adjust delay as needed

    // Add the listener
    if (mediaQuery.addEventListener) 
      mediaQuery.addEventListener("change", handleChange);
    else 
        mediaQuery.addListener(handleChange); // for specifically safari browser 

    return () => {
        if (mediaQuery.removeEventListener) 
            mediaQuery.removeEventListener("change", handleChange);
        else 
            mediaQuery.removeListener(handleChange); // legacy fallback

      handleChange.cancel(); // Cancel debounce on cleanup
    };
  }, []);

  return isMobile;
};

export default useCheckMobileScreen;
